import { render, staticRenderFns } from "./DefaultErrorScreen.vue?vue&type=template&id=0cec5714&scoped=true"
import script from "./DefaultErrorScreen.vue?vue&type=script&lang=js"
export * from "./DefaultErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./DefaultErrorScreen.vue?vue&type=style&index=0&id=0cec5714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec5714",
  null
  
)

export default component.exports